import React from "react";
import { audiences, practicePieces } from "../data/content";
import { SectionHeading } from "./SectionHeading";
export function SolutionSection() {
  return <section className="bg-forest py-16 text-white md:py-24" data-id="element-266" data-mp="3abvpns5kmc0u">
      <div className="wrap grid items-center gap-12 md:grid-cols-2 md:gap-16" data-id="element-267" data-mp="3oa3grjfxej43">
        <div data-id="element-268" data-mp="3j9xvqm45vuuz">
          <SectionHeading tone="dark" align="left" eyebrow="La solución" title={<>
                De sacar al azar a <span className="text-gold" data-id="element-270" data-mp="3t8wwliioqm7f">saber qué hacer.</span>
              </>} data-id="element-269" data-mp="3j9ftn8utimf5" />
          <div className="mt-6 space-y-4 text-[17px] text-haze" data-id="element-271" data-mp="aunnsxdlbvfa">
            <p data-id="element-272" data-mp="aw8icmzwned5">
              Tu iPhone, Tu Estudio conecta cada herramienta de la cámara con una situación real de tu negocio. Elegís
              qué mostrar y seguís los pasos para preparar, fotografiar o grabar y revisar el resultado.
            </p>
            <p data-id="element-273" data-mp="fus4ooieus61">
              Es parte de las guías digitales de <strong className="text-white" data-id="element-274" data-mp="36am2xj4m6s2d">Celulares Nuevos Saavedra</strong>,
              presentado por Marcio.
            </p>
          </div>
          <p className="mt-8 text-xs font-bold uppercase tracking-[2px] text-gold" data-id="element-275" data-mp="3bai6xidbajhx">Pensado para</p>
          <ul className="mt-3 flex list-none flex-wrap gap-2 p-0" aria-label="Tipos de emprendimiento" data-id="element-276" data-mp="3faivvwy1ed38">
            {audiences.map(audience => <li key={audience} className="rounded-full border border-white/15 bg-forest-soft px-3.5 py-1.5 text-sm" data-id="element-277" data-mp="3p9hsui9fwkae">
                {audience}
              </li>)}
          </ul>
        </div>

        <div className="rounded-2xl border border-gold/30 bg-forest-deep p-7 md:p-9" data-id="element-278" data-mp="2u5j0gqyi213">
          <span className="text-xs font-bold uppercase tracking-[2px] text-gold" data-id="element-279" data-mp="6vh9splkgtav">Tu recorrido práctico</span>
          <h3 className="display-title mt-2 text-[34px] leading-none" data-id="element-280" data-mp="butvh70pbubv">Un producto. Cinco piezas para mostrarlo.</h3>
          <ol className="mt-6 list-none p-0" data-id="element-281" data-mp="gt52l9zm3qqe">
            {practicePieces.map((piece, index) => <li key={piece.title} className="flex gap-4 border-b border-white/10 py-4 last:border-0 last:pb-0" data-id="element-282" data-mp="2cw1j33a5tbrv" data-mpi={index}>
                <span className="display-title w-7 shrink-0 text-2xl text-gold" data-id="element-283" data-mp="27yrkax0vrnrd">{index + 1}</span>
                <div data-id="element-284" data-mp="2mno05g96i52j">
                  <strong className="block" data-id="element-285" data-mp="2mnxhkfg5r3wm">{piece.title}</strong>
                  <span className="text-sm text-haze" data-id="element-286" data-mp="2hvmfb5xy360w">{piece.body}</span>
                </div>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}